module.exports = __webpack_public_path__ + "static/media/fundo.aac87699.png";